function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloudUpload = function SvgCloudUpload(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.274 40.434",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M47.565 10.671a20.221 20.221 0 0 0-37.691 5.788 12.09 12.09 0 0 0 2.216 23.975h17.223V25.13L25.447 29a1.825 1.825 0 0 1-2.58-2.58l6.98-6.98a1.824 1.824 0 0 1 2.58 0l6.98 6.98a1.825 1.825 0 1 1-2.58 2.58l-3.866-3.87v15.3h14.431a14.882 14.882 0 0 0 .173-29.763Zm0 0",
    "data-name": "cloud-computing (3)",
    style: {
      fill: "#414a5f"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloudUpload);
export default ForwardRef;